import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ConfigProvider, Modal, Button, Space, Typography } from 'antd'
import { ReloadOutlined, DownloadOutlined } from '@ant-design/icons'
import viVN from 'antd/locale/vi_VN'
import App from './App'
import './index.css'
import './styles/font.css'
import { useState } from 'react'
import { disableConsoleInProduction } from './utils/disableConsole'

disableConsoleInProduction();

const { Text } = Typography;

// Component để quản lý update modal
const UpdateModal = () => {
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [newVersion, setNewVersion] = useState('');

  const handleUpdate = () => {
    setIsUpdating(true);
    // Gửi message để skip waiting
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
    }
    // Reload sau 1 giây để đảm bảo service worker đã cập nhật
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const handleLater = () => {
    setIsUpdateModalOpen(false);
  };

  // Expose functions globally để service worker có thể gọi
  (window as any).showUpdateModal = (version: string) => {
    setNewVersion(version);
    setIsUpdateModalOpen(true);
  };

  return (
    <Modal
      title={
        <Space>
          <DownloadOutlined style={{ color: '#1890ff' }} />
          <span>Cập nhật phiên bản mới</span>
        </Space>
      }
      open={isUpdateModalOpen}
      onCancel={handleLater}
      footer={[
        <Button key="later" onClick={handleLater}>
          Để sau
        </Button>,
        <Button
          key="update"
          type="primary"
          icon={<ReloadOutlined />}
          loading={isUpdating}
          onClick={handleUpdate}
        >
          {isUpdating ? 'Đang cập nhật...' : 'Cập nhật ngay'}
        </Button>
      ]}
      centered
      maskClosable={false}
      closable={false}
    >
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <Text style={{ fontSize: '16px', display: 'block', marginBottom: '12px' }}>
          Phiên bản mới đã sẵn sàng!
        </Text>
        {newVersion && (
          <Text type="secondary" style={{ display: 'block', marginBottom: '16px' }}>
            Phiên bản: <Text code>{newVersion}</Text>
          </Text>
        )}
        <Text type="secondary">
          Cập nhật sẽ giúp bạn có trải nghiệm tốt hơn với các tính năng mới và sửa lỗi.
        </Text>
      </div>
    </Modal>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Component chính với update modal
const AppWithUpdateModal = () => {
  return (
    <>
      <App />
      <UpdateModal />
    </>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <ConfigProvider locale={viVN}>
      <BrowserRouter>
        <AppWithUpdateModal />
      </BrowserRouter>
    </ConfigProvider>
  </QueryClientProvider>,
)

// Service Worker Registration với version checking
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        // Kiểm tra version mới
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Có version mới, hiển thị modal
                // Lấy version từ service worker nếu có thể
                const currentVersion = (window as any).APP_VERSION || 'Mới';
                (window as any).showUpdateModal?.(currentVersion);
              }
            });
          }
        });
        
        // Kiểm tra khi service worker thay đổi
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          // Tránh hiển thị thêm một thông báo, reload nhẹ sau khi service worker sẵn sàng
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
} 